import styled, { css } from "styled-components";
import { Link } from "../../components";
import { maxLayout } from "../../utils/breakpoint/breakpoint";

export const TabContainer = styled.div`
  display: flex;
  flex-direction: row;
  > :not(:last-child) {
    margin-right: 4px;
  }
  @media ${maxLayout.lg} {
    display: none;
  }
`;

export const Tab = styled(Link)<{ isActive?: boolean }>`
  padding: var(--space-s) var(--space-base);
  border-radius: 3px 3px 0 0;
  cursor: pointer;
  text-decoration: none;
  color: ${(props) => props.theme.colors.grey300};
  background: ${(props) => props.theme.colors.overlay};
  :hover {
    background: ${(props) => props.theme.colors.overlayHover};
  }
  ${(props) => {
    if (props.isActive) {
      return css`
        color: ${props.theme.colors.navy};
        background: ${props.theme.colors.lightBlue};
        :hover {
          background: ${props.theme.colors.lightBlue};
        }
      `;
    }
  }}
`;
